import React from "react";
import { getSystemExemptedLates } from "@utils/utils";

const ExemptBySystem = ({ late_arrivals }) => {
  return late_arrivals > 0 ? (
    <div className="col-6">
      <h5 style={fieldsLabel}>
        <b>Exempted by system: </b>
        {getSystemExemptedLates(late_arrivals)}
      </h5>
    </div>
  ) : null;
};

const fieldsLabel = {
  fontWeight: 500,
  fontSize: "14px",
  textAlign: "left",
};

export default ExemptBySystem;
